<template>
  <b-sidebar :id="'sidebar-event-report-' + recording.id" :title="recording.name" sidebar-class="bb-offcanvas-panel full"
             width="100%" @change="onLtiPanelVisibilityChange" @shown="initReports" @hidden="clearReports"
             bg-variant="white" right backdrop-variant="dark" backdrop no-header shadow>
    <template #default="{ hide }">
      <div class="bb-offcanvas-panel-wrap">
        <div class="panel-main-content" v-if="!show_report">
          <header class="page-header page-header-collapsed">
            <div class="page-title-wrapper page-title-report-sidebar">
              <h1 class="page-title"><bdi>{{ $t("recordings.reports.title", {title: recording.name}) }}</bdi></h1>
            </div>
            <button class="bb-close" v-on:click="hide">
              <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
            </button>
          </header>
          <div id="body-content" class="body-content instances-container">
            <div v-if="!loading" class="full-width-content--small div-content-report-sidebar">
              <div v-if="!reports.length" class="no-content no-results">
                <span class="image pb-3">
                  <img class="site-logo" src="/static/img/miroodles_sticker.png">
                </span>
                <span class="no-content-title">{{ $t("recordings.reports.no_reports_found") }}</span>
              </div>
              <table v-if="reports.length" class="content-table report-table">
                <tbody>
                <tr class="content-table__header content-table__header--shadow">
                  <th>{{ $t("recordings.reports.name") }}</th>
                  <th>{{ $t("recordings.reports.unir_id") }}</th>
                  <th>{{ $t("recordings.reports.completed") }}</th>
                  <th>{{ $t("recordings.reports.events") }}</th>
                </tr>
                <tr v-for="report in reports" v-bind:key="report.id" class="element-list-row" bb-attendance-instance-row>
                  <td class="">
                    <span class="inline-column-title">{{ $t("recordings.reports.name") }}:</span>
                    <span>{{ report.userName }}</span>
                  </td>
                  <td class="">
                    <span class="inline-column-title">{{ $t("recordings.reports.unir_id") }}:</span>
                    <span>{{ getUserUnir(report) }}</span>
                  </td>
                  <td class="">
                    <span class="inline-column-title">{{ $t("recordings.reports.completed") }}:</span>
                    <span>{{ report.percentage.toFixed(2) }}%</span>
                  </td>
                  <td class="attendance-column">
                    <button class="button text" @click="showReport(report)">
                      {{ $t("sessions.reports.seereport") }}
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- else: show_report == True -->
        <div class="panel-main-content" v-else>
          <header class="page-header page-header-collapsed">
            <div class="page-title-wrapper">
              <a class="button button--icon -inverse previous-panel has-tooltip" id="tooltip-back" @click="hideReport()">
                <i class="isax isax-arrow-left"></i>
              </a>
              <b-tooltip target="tooltip-back" triggers="hover">
                {{ $t("sessions.reports.backward") }}
              </b-tooltip>
              <h1 class="page-title">{{ $t("recordings.reports.title", {title: recording.name}) }}</h1>
            </div>
            <button class="bb-close" v-on:click="hide">
              <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
            </button>
          </header>
          <div class="content-container container-fluid pt-2">
            <div class="row">
              <aside class="panel-aside col-sm-12 col-md-3 col-lg-2 redirect-detail aside-report-detail">
                <ul class="tool-list">
                  <li>
                    <h3>{{ $t("recordings.reports.eventsdetails") }}</h3>
                    <div class="tool-list-info instance-detail">
                      <div class="tool-list-title">
                        <span>{{ $t("recordings.reports.name") }}</span>
                      </div>
                      <div class="tool-list-detail">
                        <span>{{ current_report.userName }}</span>
                      </div>
                      <div class="tool-list-title">
                        <span>{{ $t("recordings.reports.unir_id") }}</span>
                      </div>
                      <div class="tool-list-detail">
                        <span>{{ getUserUnir(current_report) }}</span>
                      </div>
                      <div class="tool-list-title">
                        <span>{{ $t("recordings.reports.totalcompleted") }}</span>
                      </div>
                      <div class="tool-list-detail">
                        <span>{{ current_report.percentage.toFixed(2) }}%</span>
                      </div>
                      <div class="tool-list-title">
                        <span>{{ $t("recordings.reports.recordingduration") }}</span>
                      </div>
                      <div class="tool-list-detail">
                        <span>{{ msToTime(recording.duration) }}</span>
                      </div>

                      <div class="tool-list-title">
                        <span>{{ $t("recordings.reports.totalevents") }}</span>
                      </div>
                      <div class="tool-list-detail">
                        <span>{{ current_report.totalEvents }}</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <h3>{{ $t("sessions.reports.tools") }}</h3>
                    <div class="tool-list-export">
                      <div class="tool-list-info">
                        <button class="tool-list-csv-button button--text d-flex align-items-center" @click="getCSVData">
                          <i class="isax isax-document-download"></i>
                          <span>{{ $t("sessions.reports.exportreportCSV") }}</span>
                          <download-csv :data="csv_data" ref="generator" :fields="csv_fields" :labels="csv_labels"
                                        :name="recording.name + '_' + getUserUnir(current_report) + '.csv'" class="d-none">
                          </download-csv>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </aside>
              <div class="panel-content col-sm-12 col-md-9 col-lg-10 panel-content-report-detail">
                <div class="full-width-content--small attendees-list">
                  <table v-if="report_events" class="content-table report-detail-table" id="report-content-table">
                    <tbody>
                    <tr class="content-table__header content-table__header--shadow">
                      <th>{{ $t("recordings.date") }}</th>
                      <th>{{ $t("recordings.reports.init") }}</th>
                      <th>{{ $t("recordings.reports.end") }}</th>
                      <th>{{ $t("recordings.duration") }}</th>
                    </tr>
                    <tr v-for="event in report_events" :key="event.id" class="element-list-row" bb-attendee-row>
                      <td>
                        <span class="inline-column-title">{{ $t("recordings.date") }}:</span>
                        <span>{{ event.eventDate | moment("D/M/YY HH:mm:ss") }}</span>
                      </td>
                      <td>
                        <span class="inline-column-title">{{ $t("recordings.reports.init") }}:</span>
                        <span>{{ (event.init / 1000).toFixed(2) }}s</span>
                      </td>
                      <td>
                        <span class="inline-column-title">{{ $t("recordings.reports.end") }}:</span>
                        <span>{{ (event.end / 1000).toFixed(2) }}s</span>
                      </td>
                      <td>
                        <span class="inline-column-title">{{ $t("recordings.duration") }}:</span>
                        <span>{{ msToTime(event.duration) }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <footer v-if="report_pagination.limit < current_report.totalEvents" class="panel-footer session-attendee-pagination">
                  <b-pagination
                    v-model="report_pagination_current"
                    :total-rows="current_report.totalEvents"
                    :per-page="report_pagination.limit"
                    align="center"
                    aria-controls="report-content-table"
                  ></b-pagination>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import FileIcon from 'vue-material-design-icons/File.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import jwtMixin from '../../../mixins/jwtMixin'
import ltiFrameMixin from '../../../mixins/ltiFrameMixin'
import settings from '../../../setttings'

export default {
  name: 'EventsReportSidebar',
  components: {CloseIcon, KeyboardReturnIcon, CloudDownloadOutlineIcon, FileIcon},
  mixins: [utilitiesMixin, jwtMixin, ltiFrameMixin],
  props: ['recording', 'iconColor', 'returnIconColor'],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      backend_url: settings.VIDEO_EVENTS_URL,

      loading: false,
      reports: [],
      show_report: null,
      current_report: null,
      report_events: null,

      csv_data: [],
      csv_fields: ['eventDate', 'init', 'end', 'duration'],
      csv_labels: {
        eventDate: this.$i18n.t('recordings.date'),
        init: this.$i18n.t('recordings.reports.init'),
        end: this.$i18n.t('recordings.reports.end'),
        duration: this.$i18n.t('recordings.duration')
      },

      report_pagination_current: 1,
      report_pagination: {
        limit: 10,
        offset: 0
      }
    }
  },
  watch: {
    report_pagination_current: {
      handler: function (value) {
        this.report_pagination.offset = this.report_pagination_current - 1
        this.showReport()
      }
    },
    csv_data (newvalue) {
      let csvdata = newvalue.map(e => {
        e.eventDate = window.moment(e.eventDate).format('YYYY-MM-DD HH:mm:ss')
        return e
      })
      this.$refs.generator.data = csvdata
      this.$refs.generator.generate()
    }
  },
  methods: {
    async initReports () {
      this.loading = true

      try {
        let params = new URLSearchParams()
        params.append('recordingId', this.recording.id)
        params.append('duration', this.recording.duration)

        let response = await window.axios.get(this.backend_url + '/api/report', {params: params})

        this.reports = response.data
      } catch (e) {
        this.$noty.error(this.$i18n.t('recordings.reports.error_reports'), {
          timeout: 3000,
          progressBar: true
        })
      }

      this.loading = false
    },
    async showReport (report) {
      this.show_report = true
      if (report) {
        this.current_report = report
      }

      let response = await window.axios.get(this.backend_url + '/api/user-events', {
        params: {
          ...this.report_pagination,
          recordingId: this.recording.id,
          userId: this.current_report.userId
        }
      })
      this.report_events = response.data
    },
    async getCSVData () {
      let response = await window.axios.get(this.backend_url + '/api/user-events', {
        params: {

          recordingId: this.recording.id,
          userId: this.current_report.userId
        }
      })
      this.csv_data = response.data
    },
    hideReport () {
      this.show_report = false
      this.current_report = null
      this.report_events = null
    },
    clearReports () {
      this.reports = []
    },
    getUserUnir (report) {
      return report.userUnir.toUpperCase().startsWith('S') ? report.userUnir.substring(1) : report.userUnir
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/EventsReportSidebar.vue